import { j as a } from "./jsx-runtime.DGlMoOmv.js";
import * as p from "react";
import { c as r } from "./index.CxSWpsOB.js";
import { c as j } from "./index.C4-GUKyp.js";
const N = j("tw-h-40 tw-px-12 tw-py-8 tw-border-0 tw-bg-transparent tw-text-gray-900 placeholder:tw-text-gray-600 disabled:tw-text-gray-500 disabled:placeholder:tw-text-gray-500 focus:tw-outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:tw-appearance-none [&::-webkit-inner-spin-button]:tw-appearance-none", {
  variants: {
    fullWidth: {
      true: "tw-w-full",
      false: ""
    },
    error: {
      true: "tw-border-red-800 focus:tw-border-red-800",
      false: ""
    }
  }
}), v = (e) => e != null && e !== !1, k = p.forwardRef(({
  prefix: e,
  suffix: l,
  suffixText: o,
  errorMsg: s,
  testId: n = "input",
  className: m,
  fullWidth: c = !1,
  type: f = "text",
  ...t
}, b) => {
  const w = v(l), d = !!o;
  return /* @__PURE__ */ a.jsxs("div", { className: r("tw-body-2 tw-relative tw-flex tw-items-center tw-border tw-border-gray-400 tw-rounded-4 tw-bg-base-white focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-blue-800 focus-within:tw-outline-offset-1 focus-within:tw-border-gray-900", {
    "tw-w-full tw-flex-1": c,
    "tw-border-red-800 focus-within:tw-border-red-800": !!s
  }), children: [
    !!e && /* @__PURE__ */ a.jsx("span", { "data-testid": `${n}-prefix`, className: r("tw-h-40 tw-inline-flex tw-items-center tw-justify-center tw-pl-12 tw-flex-shrink-0 tw-body-2-m", {
      "tw-text-gray-500": t.disabled
    }), children: e }),
    /* @__PURE__ */ a.jsx("input", { "data-testid": n, "aria-invalid": !!s, ref: b, type: f, className: r(N({
      fullWidth: !!c,
      error: !!s,
      className: m
    })), ...t, onChange: (i) => {
      const u = i.target.value;
      if (!u || f !== "number") {
        t?.onChange?.(i);
        return;
      }
      const h = Number(u), y = t?.min ? +t.min : -1 / 0, g = t?.max ? +t.max : 1 / 0, x = Math.min(Math.max(h, y), g);
      t?.onChange?.({
        ...i,
        target: {
          ...i.target,
          value: isNaN(x) ? "" : String(x)
        }
      });
    } }),
    (w || d) && /* @__PURE__ */ a.jsxs("span", { className: r("tw-h-40 tw-inline-flex tw-items-center tw-justify-center tw-gap-8 tw-pr-12 tw-flex-shrink-0", {
      "tw-text-gray-500": t.disabled
    }), children: [
      d && /* @__PURE__ */ a.jsx("span", { "data-testid": w ? `${n}-suffix-text` : `${n}-suffix`, className: "tw-inline-flex tw-items-center tw-justify-center tw-body-1 tw-text-gray-600", children: o }),
      w && /* @__PURE__ */ a.jsx("span", { "data-testid": `${n}-suffix`, className: "tw-inline-flex tw-items-center tw-justify-center tw-body-2-m", children: l })
    ] })
  ] });
});
k.displayName = "Input";
export {
  k as I
};
//# sourceMappingURL=Input.D9O4R5sO.js.map
